var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-inventory"},[_c('div',{staticClass:"c-inventory-items"},[_vm._l((_vm.collectedItemsByType),function(items){return _vm._l((items),function(ref){
var id = ref.id;
var type = ref.type;
return _c('button',{key:id,staticClass:"c-inventory-item",class:{
          'c-inventory-item-used': _vm.itemIsUsed(id),
          'c-inventory-item-usable': !_vm.itemIsUsed(id)
        },on:{"click":function($event){return _vm.useItem(id)}}},[_vm._v(" "+_vm._s(type)+" ")])})})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }